import React from "react"

import VideoUploadPage from "../components/VideoUploadPage"

const VideoReviewUpload = ({ videoReview, practice, client, uploadHash }) => {
  console.log("VideoReviewUpload", { videoReview, practice, client, uploadHash })
  // If props received and link still valid → show recorder page.
  if (videoReview && practice && client && uploadHash && videoReview.canUpload) {
    return <VideoUploadPage videoReview={videoReview} practice={practice} client={client} uploadHash={uploadHash} />
  }

  // Determine message based on what we know
  let title = "Video Review Upload"
  let message = "Loading upload information..."

  if (videoReview && !videoReview.canUpload) {
    title = "Upload Link Unavailable"
    message =
      "This upload link has already been used or has expired. If you need to submit another video, please contact your practitioner for a new link."
  } else if (!videoReview) {
    title = "Upload Link Not Found"
    message = "The link you followed is invalid or has expired. Please check the URL or request a new upload link."
  }

  return (
    <div className="mx-4 flex min-h-screen items-center justify-center bg-gray-100">
      <div className="w-full max-w-lg rounded-xl bg-white p-12 text-center shadow-xl">
        {/* Icon */}
        {videoReview && !videoReview.canUpload ? (
          <div className="bg-red-100 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            <i className="icon-warning text-3xl text-red-600" />
          </div>
        ) : !videoReview ? (
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
            <i className="icon-info text-3xl text-gray" />
          </div>
        ) : (
          <div className="bg-blue-100 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-t-transparent" />
          </div>
        )}
        <h1 className="mb-2 text-2xl font-semibold text-gray-700">{title}</h1>
        <p className="text-gray-500">{message}</p>
      </div>
    </div>
  )
}

export default VideoReviewUpload
